export const GLOBAL_CARTITEM = 'global.cartItemTile';
export const GLOBAL_ERRORS = 'global.errorMessages';
export const CHECKOUT_LABELS = 'checkout';
export const lblOrderledgerCoupons = 'lbl_orderledger_coupons';
export const lblPromotionsLabel = 'lbl_orderledger_promotions';
export const lblGiftServiceLabel = 'lbl_orderledger_giftServices';
export const lblTaxLabel = 'lbl_orderledger_tax';
export const lblTotalLabel = 'lbl_orderledger_total';
export const lblGiftcardsLabel = 'lbl_orderledger_giftcards';
export const lblBalanceLabel = 'lbl_orderledger_balance';
export const lblTotalLabelConfirmation = 'lbl_orderledger_totalConfirmation';
export const lblFree = 'lbl_orderledger_free';
export const lblTotalSavingsLabel = 'lbl_total_savings';
export const lblPaidWithVenmo = 'lbl_confirmation_paid_with_venmo';
export const lblOrderLedgerTitle = 'lbl_orderledger_title';
export const lblEstimatedTaxAddCA = 'lbl_estimated_tax_add_ca';
export const lblEstimatedTaxAdd = 'lbl_estimated_tax_add';
export const lblTooltipText = 'lbl_orderledger_tooltiptext';
export const errorMessagessErrCodeGeneric = 'lbl_errorMessagess_ERR_CODE_GENERIC';
export const estimatedTaxZipPlaceHolderCA = 'lbl_estimated_zip_placeholder_ca';

const orderLedgerLabels = {
  checkout: {
    bagPage: {
      [lblOrderledgerCoupons]: 'Coupons',
      [lblPromotionsLabel]: 'Promotions',
      [lblGiftServiceLabel]: 'Gift Service',
      [lblTaxLabel]: 'Estimated Tax',
      [lblTotalLabel]: 'Estimated Total',
      [lblGiftcardsLabel]: 'Gift Card(s)',
      [lblFree]: 'FREE',
      [lblBalanceLabel]: 'Balance',
      [lblTotalLabelConfirmation]: 'Total',
      [lblPaidWithVenmo]: 'Paid with',
      [lblOrderLedgerTitle]: 'Order Summary',
      [lblEstimatedTaxAddCA]: 'Add Postal Code',
      [lblEstimatedTaxAdd]: 'Add Zip Code',
      [lblTooltipText]:
        'Total includes any applied promotions or coupons in addition to on sale savings', // May be dynamic
      [estimatedTaxZipPlaceHolderCA]: 'Postal Code',
    },
  },
  global: {
    cartItemTile: {
      [lblTotalSavingsLabel]: 'Total Savings',
    },
    errorMessages: {
      [errorMessagessErrCodeGeneric]: 'There was an issue, please try again',
    },
  },
};

export default orderLedgerLabels;
